import { EpiscopalArea, EpiscopalAreaService } from '@gbhem/api';
import { Column } from 'react-table';

import { Table } from '../../components';

const columns = [
  {
    Header: 'NAME',
    accessor: 'name',
    id: 'name',
    Cell: ({ value }) => value
  },
  {
    Header: 'JURISDICTION',
    accessor: 'jurisdiction',
    id: 'jurisdiction',
    Cell: ({ value }) => value.name
  },
  {
    Header: 'CONFERENCES',
    accessor: 'conferences',
    id: 'conferences',
    disableSortBy: true,
    Cell: ({ value }) => value.map((c) => c.name).join(', ')
  }
] as Column<EpiscopalArea>[];

export function EpiscopalAreas() {
  const initialPageSize = 10;
  const initialPageIndex = 0;

  return (
    <Table
      columns={columns}
      data={[]}
      pageIndex={initialPageIndex}
      pageSize={initialPageSize}
      count={0}
      loader={async (props) => {
        const quickSearch = await EpiscopalAreaService.quickSearch(
          'EpiscopalArea',
          props.size,
          props.page * props.size,
          ['jurisdiction', 'conferences'],
          props.isQuickSearch,
          props.orderBy,
          props.filters
        );
        return { data: quickSearch.data, count: quickSearch.count };
      }}
    />
  );
}

export default EpiscopalAreas;
